"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Leaf } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function GardenInquiryForm() {
  return <section id="gardeninquiryform" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-10">
          
          
        </div>

        <Card className="border-border/50 shadow-lg bg-muted/10">
          <CardHeader className="pb-4 border-b border-border/30">
            <CardTitle className="text-xl font-default flex items-center gap-2">
              <Leaf className="size-5 text-primary" />
              Get in Touch
            </CardTitle>
            <CardDescription className="font-sans">
              Have questions about your garden project? Get in touch with us directly.
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-8 pb-10">
            <div className="flex flex-col items-center text-center space-y-6">
              <p className="text-muted-foreground font-sans max-w-md">
                Whether you're looking for a complete redesign or specific landscaping services, our team is ready to help bring your vision to life.
              </p>
              <Link to="mailto:info@nicklandscapes.co.uk">
                <Button size="lg" className="px-8 font-semibold">
                  Email us
                </Button>
              </Link>
              <p className="text-xs text-muted-foreground">
                We typically respond to all inquiries within 24-48 business hours.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}